import { ItineraryResponse } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import { checkIfTerminalChange } from '@/src/utils/itinerary/flightTransformers'

export type NoteConfig = {
    title: string
    getContent: (itineraryData: ItineraryResponse, t?: TranslationFunction<'common'>) => string | undefined
}

export const noteConfigs: NoteConfig[] = [
    {
        title: 'Note',
        getContent: (data, t) => (checkIfTerminalChange(data.flights) ? t?.('terminalChangeMessage') : '')
    },
    {
        title: 'Important!',
        getContent: data => data.meta?.message?.importantMessages
    },
    {
        title: 'Note',
        getContent: data => data.meta?.transitVisaMsg
    }
]
